import { InputAdornment, TextField, type InputProps } from '@mui/material';
import type { FocusEventHandler, ReactNode } from 'react';

interface AppTextFieldProps {
  name?: string;
  label: string;
  placeholder?: string;
  maxLength?: number;
  uppercase?: boolean;
  value: string | number;
  onChange?: FocusEventHandler<any>;
  onBlur?: FocusEventHandler<any>;
  error?: boolean;
  helperText?: string;
  readOnly?: boolean;
  disabled?: boolean;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  multiline?: boolean;
  rows?: number;
  maxRows?: number;
  isPassword?: boolean;
}

const AppTextField = ({
  name,
  label,
  placeholder,
  maxLength,
  uppercase,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  readOnly,
  disabled,
  startAdornment,
  endAdornment,
  multiline,
  rows,
  maxRows,
  isPassword
}: AppTextFieldProps) => {
  const inputProps: InputProps = {
    inputProps: { maxLength, style: { textTransform: uppercase ? 'uppercase' : 'none' } },
    readOnly: readOnly,
    startAdornment: startAdornment ? (
      <InputAdornment position="start">{startAdornment}</InputAdornment>
    ) : (
      <></>
    ),
    endAdornment: endAdornment ? (
      <InputAdornment position="end">{endAdornment}</InputAdornment>
    ) : (
      <></>
    )
  };

  const type = isPassword ? 'password' : 'text';

  return (
    <TextField
      fullWidth
      name={name}
      label={label}
      placeholder={placeholder}
      slotProps={{
        input: inputProps,
        formHelperText: { sx: { textAlign: error ? 'left' : 'right' } }
      }}
      // InputProps={inputProps}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      disabled={disabled}
      multiline={multiline}
      rows={rows}
      maxRows={maxRows}
      type={type}
      // FormHelperTextProps={{ sx: { textAlign: error ? 'left' : 'right' } }}
    />
  );
};

export default AppTextField;
